import GlobalSearchBarContainer from './GlobalSearchBarContainer';

export default GlobalSearchBarContainer;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/index.js